import { Card } from '../models/card'
import { CardProps } from '../models/card.props'

export const cardsMapper = {
  mapToCards(cardPropsArray: CardProps[]): Card[] {
    return cardPropsArray.map((cardProps) => new Card(cardProps))
  },
}
